module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/56.998aae3c.png";